export enum MechanicalSections {
    Vibration = "vibration",
    TravelCurve = "travelCurve",
    ContactForce = "contactForce",
    Motor = "motor",
    Coils = "coils",
}